// "Proposed Agreements" — a compact, read-only pane-1 gutter for Heather/Maria.
// Lists the tenant's in-flight CIC submissions (name · submitter · stage). Entirely
// gated by the per-user shadow_ui flag surfaced as auth.user.cic_agreements_gutter;
// Workspace only mounts this when that flag is on. Display-only for now — rows don't
// navigate yet (we can wire a click → pane-3 memo later). (Ken 2026-10-13)
import { useEffect, useState } from 'react'
import { artifacts, type AgreementGutterRow } from '../api'

const STAGE_LABEL: Record<string, string> = {
  intake: 'In intake',
  ready_for_work: 'Ready for work',
  delivered: 'Delivered',
}
const STAGE_COLOR: Record<string, string> = {
  intake: 'var(--me-textMute)',
  ready_for_work: 'var(--me-accent-fg)',
  delivered: 'var(--me-textMute)',
}

export default function AgreementsGutter() {
  const [rows, setRows] = useState<AgreementGutterRow[] | null>(null)

  useEffect(() => {
    let cancelled = false
    artifacts.agreementsGutter()
      .then((r) => { if (!cancelled) setRows(r) })
      .catch(() => { if (!cancelled) setRows([]) })
    return () => { cancelled = true }
  }, [])

  // Nothing to show (still loading, or no agreements) → render nothing, so the
  // gutter never leaves an empty box in the sidebar.
  if (!rows || rows.length === 0) return null

  return (
    <div className="mb-3 px-1">
      <div className="mb-1.5 text-[10px] font-semibold uppercase tracking-wide me-text-mute">
        Proposed Agreements
      </div>
      <div className="space-y-1.5 max-h-[34vh] overflow-y-auto pr-0.5">
        {rows.map((r) => (
          <div key={r.id} className="rounded-[6px] px-2 py-1.5"
               style={{ background: 'var(--me-surface)', border: '1px solid var(--me-border)' }}>
            <div className="text-[12px] leading-snug me-text break-words">{r.name}</div>
            <div className="mt-0.5 flex items-center justify-between gap-2 text-[10.5px]">
              <span className="me-text-mute truncate">{r.submitter || '—'}</span>
              <span className="shrink-0 font-medium" style={{ color: STAGE_COLOR[r.stage] || 'var(--me-textMute)' }}>
                {STAGE_LABEL[r.stage] || r.stage}{r.overdue ? ' · overdue' : ''}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
